import { render, staticRenderFns } from "./SnssaiProfileIds.vue?vue&type=template&id=c204cd4e&"
import script from "./SnssaiProfileIds.vue?vue&type=script&lang=js&"
export * from "./SnssaiProfileIds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports